import React from "react";
import Loading from "./Loading";

const CardInfo = (props) => (
  <div className={props.className}>
    <div className="inner">
      {props.loading ? (
        <Loading loading={props.loading} margin={"0px"} size={72} color={"black"} />
      ) : (
        <>
          <h3>{props.information}</h3>
          <p>{props.title}</p>
        </>
      )}
      <div className="icon" >
        <i className={props.icon} />
      </div>
    </div>   
  </div>
);

export default CardInfo;